export default "__VITE_ASSET___8gG$vts__"